import { screenNameConstants, viewPathConstants } from "../../constants";
import Spots from "./Views/Spots/Spots";
import SubscriptionSettings from "./Views/SubscriptionSettings/SubscriptionSettings";
import Instructors from "./Views/Instructors/Instructors";
import Competitions from "./Views/Competitions/Competitions";
import AddCompetitions from "./Views/Competitions/Components/AddCompetitions";
import User from "./Views/Users/User";
import AdminCourses from "./Views/Courses/AdminCourses";
import { Navigate } from "react-router-dom";
import Events from "./Views/Events/Events";
import EventForm from "./Views/Events/Components/EventForm";
import Event from "./Views/Events/Event";
import RefundPolicy from "./Views/RefundPolicy/RefundPolicy";
import ViewCompetitionDetails from "./Views/Competitions/Components/ViewCompetitionDetails";
import Centers from "./Views/Centers/Centers";
import CenterProfile from "./Views/CenterProfile/CenterProfile";
import AdminPaymentHistory from "./Views/PaymentHistory/PaymentHistory";
import AdminAuditLogs from "./Views/AuditLogs/AuditLogs";
import BoatClasses from "./Views/BoatClasses/BoatClasses";

//Please remember to update AdminServerCallRoutes.js when adding new admin routes.

export const AdminRoutes = [
  // private routes
  {
    path: viewPathConstants.INSTRUCTORS,
    name: screenNameConstants.INSTRUCTORS,
    component: <Instructors />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.UNKNOWN_PATH,
    name: screenNameConstants.INSTRUCTORS,
    component: <Navigate to={viewPathConstants.INSTRUCTORS} />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.USERS,
    name: screenNameConstants.USERS,
    component: <User />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.CENTERS,
    name: screenNameConstants.CENTERS,
    component: <Centers />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.COURSES,
    name: screenNameConstants.COURSES,
    component: <AdminCourses />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.SPOTS,
    name: screenNameConstants.SPOTS,
    component: <Spots />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.CENTER_PROFILE,
    name: screenNameConstants.CENTER_PROFILE,
    component: <CenterProfile />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.SUBSCRIPTION_SETTINGS,
    name: screenNameConstants.SUBSCRIPTION_SETTINGS,
    component: <SubscriptionSettings />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.REFUND_POLICY,
    name: screenNameConstants.REFUND_POLICY,
    component: <RefundPolicy />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.COMPETITIONS,
    name: screenNameConstants.COMPETITIONS,
    component: <Competitions />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.EVENTS,
    name: screenNameConstants.EVENTS,
    component: <Events />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.ADD_COMPETITIONS,
    name: screenNameConstants.COMPETITIONS,
    component: <AddCompetitions />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.EVENTS_FORM,
    name: screenNameConstants.EVENTS_FORM,
    component: <EventForm />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.VIEW_COMPETITIONS,
    name: screenNameConstants.VIEW_COMPETITIONS,
    component: <ViewCompetitionDetails />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.EVENT,
    name: screenNameConstants.EVENT,
    component: <Event />,
    protected: true,
    hasSideBar: true,
  },
  {
    path: viewPathConstants.ADMIN_PAYMENT_HISTORY,
    name: screenNameConstants.ADMIN_PAYMENT_HISTORY,
    component: <AdminPaymentHistory />,
    protected: true,
    hasSideBar: true,
  },
  // {
  //   path: viewPathConstants.ADMIN_AUDIT_LOGS,
  //   name: screenNameConstants.ADMIN_AUDIT_LOGS,
  //   component: <AdminAuditLogs />,
  //   protected: true,
  //   hasSideBar: true,
  // },
  {
    path: viewPathConstants.BOAT_CLASSES,
    name: screenNameConstants.BOAT_CLASSES,
    component: <BoatClasses />,
    protected: true,
    hasSideBar: true,
  },
];
